import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Polyfill para crypto.randomUUID — iOS < 15.4 não tem esta função
export function randomId() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = (Math.random() * 16) | 0;
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
}

// Format currency in Portuguese format (€)
export function formatCurrency(value) {
  if (value === null || value === undefined) return '€ 0,00';
  return new Intl.NumberFormat('pt-PT', {
    style: 'currency',
    currency: 'EUR'
  }).format(value);
}

// Format percentage
export function formatPercent(value) {
  if (value === null || value === undefined) return '0%';
  return `${value.toFixed(1)}%`;
}

// Format date in Portuguese format
export function formatDate(date) {
  if (!date) return '-';
  const d = new Date(date);
  return new Intl.DateTimeFormat('pt-PT', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  }).format(d);
}

// Format datetime
export function formatDateTime(date) {
  if (!date) return '-';
  const d = new Date(date);
  return new Intl.DateTimeFormat('pt-PT', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  }).format(d);
}

// Check if margin is low (< 15%)
export function isLowMargin(margin) {
  return margin < 15;
}

// Get status badge class
export function getStatusClass(status) {
  switch (status) {
    case 'pending': return 'badge-pending';
    case 'confirmed': return 'badge-confirmed';
    case 'shipped': return 'badge-shipped';
    case 'delivered': return 'badge-delivered';
    default: return 'badge-pending';
  }
}

// Get status label in Portuguese
export function getStatusLabel(status) {
  switch (status) {
    case 'pending': return 'Por enviar';
    case 'delivered': return 'Entregue';
    case 'cancelled': return 'Cancelado';
    default: return status;
  }
}

// Get status badge color classes
export function getStatusBadgeClass(status) {
  switch (status) {
    case 'pending': return 'bg-amber-500/10 text-amber-400 border-amber-500/20';
    case 'delivered': return 'bg-emerald-500/10 text-emerald-400 border-emerald-500/20';
    case 'cancelled': return 'bg-red-500/10 text-red-400 border-red-500/20';
    default: return 'bg-slate-500/10 text-slate-400 border-slate-500/20';
  }
}

// Export to CSV
export function downloadCSV(filename, url) {
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
